import { useMemo } from "react";

import { multiCityCodes } from "@/constants/customCode";
import { useGlobalStoreContext } from "@/context/globalStoreContext";

export const useMultiCityCodes = () => {
  const store = useGlobalStoreContext();
  return useMemo(() => {
    const codes = store.multicity_codes || {};

    const customCodes = Object.entries(codes).map(([code, { description, airports }]) => ({
      code,
      description,
      airports,
      type: "custom",
    }));

    const staticCodes = multiCityCodes.map((code) => ({
      ...code,
      type: "default",
    }));

    return {
      combinedCodes: [...customCodes, ...staticCodes],
      customCodes: customCodes,
      staticCodes: staticCodes,
    };
  }, [store.multicity_codes]);
};
